import { resolveRelease } from '@libs/focus-frontend-build/src/releaseManifest';
import type { Manifest, Release } from '@libs/focus-frontend-build/src/releaseManifest';

export const MANIFEST_URL = `${environment.RELEASE_MANIFEST_URL}/releases`;
export const RELOADED_FOR_MANIFEST = 'focus-frontend-reloaded-for-manifest';

let releasePromise: Promise<Release | undefined> | null = null;

export const fetchManifest = async (): Promise<Manifest | undefined> => {
  try {
    const response = await fetch(MANIFEST_URL, { cache: 'no-store' });
    return response.ok ? ((await response.json()) as Manifest) : undefined;
  } catch {
    return undefined;
  }
};

const hasReloaded = () => {
  try {
    return window.sessionStorage.getItem(RELOADED_FOR_MANIFEST) === 'true';
  } catch {
    return true;
  }
};

const rememberReload = () => {
  try {
    window.sessionStorage.setItem(RELOADED_FOR_MANIFEST, 'true');
  } catch {
    return;
  }
};

export const reloadOnce = () => {
  if (hasReloaded()) {
    return;
  }
  rememberReload();
  window.location.reload();
};

const resolveRunningRelease = async () => {
  const manifest = await fetchManifest();

  if (!manifest) {
    return undefined;
  }

  const release = resolveRelease(manifest, environment.BUILD_IDENTIFIER);

  if (!release) {
    reloadOnce();
  }

  return release;
};

export const resolvedRelease = () => {
  if (!releasePromise) {
    releasePromise = resolveRunningRelease();
  }

  return releasePromise;
};

export const resetResolvedRelease = () => {
  releasePromise = null;
};
